import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { AsyncPipe } from "@angular/common";
import { Observable, of } from "rxjs";
import { ButtonModule } from "@storeblocks/button-ng";
import { DialogService } from "src/app/services/dialog/dialog.service";
import { DialogRef } from "src/app/services/dialog/dialog-ref";
import { environment } from "src/environments/environment";
import { DevPanelModalComponent } from "./dev-panel-modal/dev-panel-modal.component";
import { AiMockChatComponent } from "./ai-mock-chat/ai-mock-chat.component";

@Component({
  selector: "app-dev",
  templateUrl: "./dev.component.html",
  styleUrls: ["./dev.component.scss"],
  standalone: true,
  imports: [ButtonModule, AsyncPipe, AiMockChatComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevComponent {
  private readonly dialogService = inject(DialogService);
  private dialogRef?: DialogRef<DevPanelModalComponent>;

  public readonly devModeIndicator$: Observable<string | undefined> = of(environment.appVersion);

  openDevPanel(): void {
    if (this.dialogRef) {
      return;
    }

    this.dialogRef = this.dialogService.open(DevPanelModalComponent, { panelClass: "dev-panel-modal" });
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = undefined;
    });
  }
}
